import { initialValidations } from "_common/ssrWrapper";
import ActivatePage           from "_components/pages/activate";

function Live () {
	return (
		<ActivatePage />
	);
}

const getServerSideProps = async context => initialValidations ( context, async defaultProps => {
	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=120, stale-while-revalidate=600"
  ); */

	return {
		props: {
			...defaultProps,
			noLayout : true,
			darkMode : true
		}
	};
} );

export { getServerSideProps };

export default Live;
